/* eslint-disable max-len */
import React from 'react';
import { IconProps } from '../IconProps';
import { SVGWrapper } from '../SVGWrapper';

const LocationsNavigationIcon: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style}>
        <path d="M1.1,21.6H2h4.6h0.6h3h3.6h3h0.6H22h0.9" />
        <path
            d="M22,21.6V6.1c0-0.4-0.3-0.7-0.7-0.7h-3.9v-2c0-0.5-0.4-1-1-1H7.6c-0.5,0-1,0.4-1,1v2H2.7C2.3,5.4,2,5.7,2,6.1
	v15.6"
        />
        <line x1="17.4" y1="5.4" x2="17.3" y2="21.6" />
        <line x1="6.6" y1="5.4" x2="6.6" y2="21.6" />
        <path
            stroke="none"
            fill={color}
            d="M15.4,7.4c0,0.2-0.3,0.4-0.6,0.4H9.3c-0.3,0-0.6-0.2-0.6-0.4v-3c0-0.2,0.3-0.4,0.6-0.4h5.5
		c0.3,0,0.6,0.2,0.6,0.4V7.4z"
        />
        <path
            stroke="none"
            fill={color}
            d="M20.6,8.1c0,0.2-0.3,0.4-0.6,0.4h-0.5c-0.3,0-0.6-0.2-0.6-0.4V7.2c0-0.2,0.3-0.4,0.6-0.4H20
		c0.3,0,0.6,0.2,0.6,0.4V8.1z"
        />
        <path
            stroke="none"
            fill={color}
            d="M20.6,10.5c0,0.2-0.3,0.4-0.6,0.4h-0.5c-0.3,0-0.6-0.2-0.6-0.4V9.6c0-0.2,0.3-0.4,0.6-0.4H20
		c0.3,0,0.6,0.2,0.6,0.4V10.5z"
        />
        <path
            stroke="none"
            fill={color}
            d="M5.3,8.1c0,0.2-0.3,0.4-0.6,0.4H4.1c-0.3,0-0.6-0.2-0.6-0.4V7.2c0-0.2,0.3-0.4,0.6-0.4h0.5
		C5,6.8,5.3,7,5.3,7.2V8.1z"
        />
        <path
            stroke="none"
            fill={color}
            d="M5.3,10.5c0,0.2-0.3,0.4-0.6,0.4H4.1c-0.3,0-0.6-0.2-0.6-0.4V9.6c0-0.2,0.3-0.4,0.6-0.4h0.5
		c0.3,0,0.6,0.2,0.6,0.4V10.5z"
        />
        <path
            stroke="none"
            fill={color}
            d="M20.6,12.9c0,0.2-0.3,0.4-0.6,0.4h-0.5c-0.3,0-0.6-0.2-0.6-0.4V12c0-0.2,0.3-0.4,0.6-0.4H20
		c0.3,0,0.6,0.2,0.6,0.4V12.9z"
        />
        <path
            stroke="none"
            fill={color}
            d="M10.4,10.1c0,0.2-0.3,0.4-0.6,0.4H9.3c-0.3,0-0.6-0.2-0.6-0.4V9.2c0-0.2,0.3-0.4,0.6-0.4h0.5
		c0.3,0,0.6,0.2,0.6,0.4V10.1z"
        />
        <path
            stroke="none"
            fill={color}
            d="M10.4,12.4c0,0.2-0.3,0.4-0.6,0.4H9.3c-0.3,0-0.6-0.2-0.6-0.4v-0.9c0-0.2,0.3-0.4,0.6-0.4h0.5
		c0.3,0,0.6,0.2,0.6,0.4V12.4z"
        />
        <path
            stroke="none"
            fill={color}
            d="M10.4,14.8c0,0.2-0.3,0.4-0.6,0.4H9.3c-0.3,0-0.6-0.2-0.6-0.4v-0.9c0-0.2,0.3-0.4,0.6-0.4h0.5
		c0.3,0,0.6,0.2,0.6,0.4V14.8z"
        />
        <path
            stroke="none"
            fill={color}
            d="M12.9,10.1c0,0.2-0.3,0.4-0.6,0.4h-0.5c-0.3,0-0.6-0.2-0.6-0.4V9.2c0-0.2,0.3-0.4,0.6-0.4h0.5
		c0.3,0,0.6,0.2,0.6,0.4V10.1z"
        />
        <path
            stroke="none"
            fill={color}
            d="M12.9,12.4c0,0.2-0.3,0.4-0.6,0.4h-0.5c-0.3,0-0.6-0.2-0.6-0.4v-0.9c0-0.2,0.3-0.4,0.6-0.4h0.5
		c0.3,0,0.6,0.2,0.6,0.4V12.4z"
        />
        <path
            stroke="none"
            fill={color}
            d="M12.9,14.8c0,0.2-0.3,0.4-0.6,0.4h-0.5c-0.3,0-0.6-0.2-0.6-0.4v-0.9c0-0.2,0.3-0.4,0.6-0.4h0.5
		c0.3,0,0.6,0.2,0.6,0.4V14.8z"
        />
        <path
            stroke="none"
            fill={color}
            d="M15.4,10.1c0,0.2-0.3,0.4-0.6,0.4h-0.5c-0.3,0-0.6-0.2-0.6-0.4V9.2c0-0.2,0.3-0.4,0.6-0.4h0.5
		c0.3,0,0.6,0.2,0.6,0.4V10.1z"
        />
        <path
            stroke="none"
            fill={color}
            d="M15.4,12.4c0,0.2-0.3,0.4-0.6,0.4h-0.5c-0.3,0-0.6-0.2-0.6-0.4v-0.9c0-0.2,0.3-0.4,0.6-0.4h0.5
		c0.3,0,0.6,0.2,0.6,0.4V12.4z"
        />
    </SVGWrapper>
);

export default LocationsNavigationIcon;
